var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    accordion: true,
    active: this.isActive
  }},[_c('h3',{staticClass:"heading",on:{"click":_vm.toggleActive}},[_c('button',{attrs:{"id":'accordion-control-' + _vm.itemKey,"type":"button"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"icon-container"},[_c('vue-fontawesome',{class:{
            icon: true,
            spun: !this.isActive
          },attrs:{"icon":['far', _vm.isActive ? 'minus' : 'plus']}})],1)])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"collapsible",attrs:{"id":'accordion-panel-' + _vm.itemKey}},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"is-half image-wrapper",style:({
          order: _vm.order,
          padding: _vm.order > 0 ? '0 0 0 3rem' : '0 3rem 0 0'
        })},[_c('img',{attrs:{"src":`https://static.porscheautoinsurance.com/images/homepage/${_vm.image}`,"alt":""}})]),_c('div',{staticClass:"accordion-content is-half",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }